// src/components/strumenti/CampoFotovoltaico.js — W442. Numero di moduli, kWp effettivi e rapporto DC/AC
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, Avviso, fmt } from "./UiStrumento";
import { campoFotovoltaico } from "../../utils/calcoliStrumenti";

export default function CampoFotovoltaico() {
  const { v, set, n, azzera } = useCampi({ kwp:"", wp:"", inv:"", mq:"" });
  const r = campoFotovoltaico(n("kwp"), n("wp"), n("inv"), n("mq"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Potenza desiderata (kWp)" valore={v.kwp} onChange={set("kwp")} placeholder="Es. 6"/>
        <Campo etichetta="Potenza del modulo (Wp)" valore={v.wp} onChange={set("wp")} placeholder="Es. 430"/>
        <Campo etichetta="Potenza AC inverter (kW, facoltativo)" valore={v.inv} onChange={set("inv")} placeholder="Es. 5"/>
        <Campo etichetta="Superficie del modulo (m², facoltativo)" valore={v.mq} onChange={set("mq")} placeholder="Es. 1,95"/>
      </Griglia>
      {r?.rapportoDcAc && (r.rapportoDcAc > 1.35 || r.rapportoDcAc < 0.8) && <Avviso>Rapporto DC/AC {fmt(r.rapportoDcAc, 2)}: fuori dall'intervallo usuale (circa 0,8–1,35). Verifica sul datasheet dell'inverter la potenza DC massima ammessa.</Avviso>}
      <Risultato settore="fotovoltaico" titolo="Moduli necessari" valore={r ? String(r.moduli) : "—"}
        righe={r ? [["Potenza effettiva", fmt(r.kwp, 3) + " kWp"], r.rapportoDcAc !== null && ["Rapporto DC/AC", fmt(r.rapportoDcAc, 2)], r.superficie !== null && ["Superficie dei moduli", fmt(r.superficie, 1) + " m²"]] : []}/>
      <Formula>Moduli = kWp × 1000 ÷ Wp del modulo, arrotondato per eccesso; kWp effettivi = moduli × Wp ÷ 1000; DC/AC = kWp ÷ kW inverter. Non verifica tensioni di stringa e MPPT: usa anche «N° massimo/minimo pannelli in serie».</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
